import * as React from 'react';
import { ProviderPropsTypes } from 'src/models/types/ProviderPropsTypes';

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  MsalAuthenticationTemplate,
} from '@azure/msal-react';
import LayoutClosedSession from '../components/layoutClosedSession';
import { InteractionType } from '@azure/msal-browser';

function ErrorComponent(error: any) {
  return <p>An Error Occurred: {error}</p>;
}

function LoadingComponent() {
  return <p>Authentication in progress...</p>;
}

/**
 * @function AzureADProvider
 * @description Provider Connection Azure Active Directory.
 * @param {React.ReactNode} children
 * @returns {React.FC<ProviderPropsTypes>}
 */
export const AzureADProvider: React.FC<ProviderPropsTypes> = ({ children }: ProviderPropsTypes) => {
  return (
    <>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        errorComponent={ErrorComponent}
        loadingComponent={LoadingComponent}
      >
        <AuthenticatedTemplate>
          {children}
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <LayoutClosedSession />
        </UnauthenticatedTemplate>
      </MsalAuthenticationTemplate>
    </>
  );
}
